package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.di.koinGet
import io.horion.cv.styles.PersonalFormFullWidthStyle
import io.horion.cv.styles.PersonalFormMainColumnStyle
import org.jetbrains.compose.web.css.px


@OptIn(DelicateApi::class)
@Composable
fun SituationForm() {
    val letterViewModel = koinGet<LetterViewModel>()
    val letterUiState = letterViewModel.letterUiState

    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {
        RichTextDescription(
            label = "Situation",
            value = letterUiState.data.situation,
            onValueChange = { html ->
                letterViewModel.updateSituation(html)
            },
            modifier = PersonalFormFullWidthStyle.toModifier()
        )
    }
}
